import Http from "./base-http";

class UserDepartment extends Http {
  addUserDepartment(variables) {
    return this.create(variables);
  }
  deleteUserDept(id) {
    return this.destroy(id);
  }
}
const userDepartment = new UserDepartment({
  modelUrlPrefix : "UserDepartment"
});
export default userDepartment;